(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
  const button = event.target.closest('.nine-line-donation__button');

  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  const originalText = button.textContent;

  button.disabled = true;
  button.textContent = 'Ajout...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1
        }]
      })
    });

    if (!response.ok) throw new Error();

    sessionStorage.setItem('reopenCartAfterDonation', 'true');
    window.location.reload();

  } catch (error) {
    button.disabled = false;
    button.textContent = originalText;
    alert("Le don n'a pas pu être ajouté.");
  }
});

window.addEventListener('load', function() {
  if (sessionStorage.getItem('reopenCartAfterDonation') === 'true') {
    sessionStorage.removeItem('reopenCartAfterDonation');

    setTimeout(function() {
      const drawer = document.querySelector('#cart-drawer');
      const dialog = drawer?.querySelector('dialog');

      if (dialog && !dialog.open) {
        dialog.showModal();
      }
    }, 300);
  }
});
  } catch(e) { console.error(e); }
})();

})();
